import { __assign } from "tslib";
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiEventType } from '../../../biLogger';
import Notification from '../../../Notifications/Notification';
import SystemNotification from '../../../SystemNotification';
import AddToFaveIcon from '../../../Icons/24x24/AddedToFav';
import ErrorIcon from '../../../Icons/CloseBold';
import { usePopover } from '../../../Popovers/redux/hooks';
import { PopoverType } from '../../../Popovers/redux/types';
import { useCustomNotifications } from '../../../Notifications/CustomNotificationContext';
import { NotificationType } from '../../../Notifications';
export var GroupAddedNotification = function (_a) {
    var id = _a.id, queueName = _a.queueName, success = _a.success, error = _a.error, deviation = _a.deviation, needsVote = _a.needsVote, actionbarType = _a.actionbarType, username = _a.group.username;
    var t = useTranslation().t;
    var group = username || t('common.group');
    var messageType = needsVote ? 'suggested' : 'added';
    var errorMessage = error || t("addToGroup.notification.fail");
    var pushAddToGroupPopover = usePopover(actionbarType === 'primary'
        ? PopoverType.ADD_TO_GROUP_PRIMARY
        : PopoverType.ADD_TO_GROUP_SECONDARY).pushPopover;
    var removeNotification = useCustomNotifications([
        NotificationType.AddToGroup2,
    ]).removeNotification;
    var onAddToAnotherGroup = function () {
        pushAddToGroupPopover();
        removeNotification(id);
    };
    return (React.createElement(Notification, { id: id, queueName: queueName, cardComponent: SystemNotification, cardProps: __assign(__assign({ iconComponent: success ? AddToFaveIcon : ErrorIcon, backgroundDeviation: deviation }, (error && {
            multiLine: true,
            limitTextWidth: false,
        })), { actions: [
                {
                    label: t('addToGroup.notification.addToAnotherGroup'),
                    onClick: onAddToAnotherGroup,
                    biData: {
                        evid: BiEventType.ADD_TO_GROUP_CLICK,
                        deviationid: deviation.deviationId,
                        sectionname: success ? 'add_to_another_group' : 'add_to_group_error',
                    },
                },
            ] }) }, success ? (
    // prettier-ignore
    React.createElement(Trans, { i18nKey: "addToGroup.notification." + messageType },
        "Added to ",
        React.createElement("a", { href: username && Url.userLink(username) }, { group: group }))) : (React.createElement("span", null, errorMessage))));
};
GroupAddedNotification.displayName = 'GroupAddedNotification';
export default GroupAddedNotification;
//# sourceMappingURL=GroupAddedNotification.js.map